export default [
  {
    step: "generalQuestions",
    fields: [
      {
        type: "text-area",
        id: "escalatorVAsiteSurveyFactoryOrderNo",
        maxLength:32
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveyCustomerEquipmentID",
        maxLength:32
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyManufacturer",
        options: [
          "yes",
          "no"
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyPlatform",
        options: [
          "1000",
          "1001",
          "1002",
          "1003",
          "1004",
          "1005",
          "1006",
          "1007",
          "1008",
          "1009",
          "1010",
          "1011",
          "1012",
          "1013",
          "1014",
          "1015",
          "1016",
          "1017",
          "1018",
          "1019",
          "1020",
          "1021",
          "1022",
          "1023",
          "1024",
          "1025",
          "1026",
          "1027",
          "1028",
          "1029",
          "1030",
          "1031",
          "1032",
          "1033",
          "1034",
          "1035",
          "1036",
          "1100",
          "1101",
          "1102",
          "1103",
          "1104",
          "1105",
          "1106",
          "1107",
          "1201",
          "1202",
          "1203",
          "1204",
          "1205",
          "1206",
          "1207",
          "1208",
          "1209",
          "1210",
          "1211",
          "1212",
          "1213",
          "1214",
          "1215",
          "1301",
          "1302",
          "1303",
          "1304",
          "1305",
          "1306",
          "1307",
          "1308",
          "1309",
          "1310",
          "1311",
          "1312",
          "1313",
          "1314",
          "1315",
          "1401",
          "1402",
          "1403",
          "1404",
          "1405",
          "1406",
          "1407",
          "1408",
          "1409",
          "1410",
          "1411",
          "1412",
          "1413",
          "1501",
          "1502",
          "1503",
          "1601",
          "1602",
          "1603",
          "1604",
          "1605",
          "1606",
          "1607",
          "1608",
          "1609",
          "2001",
          "2002",
          "2003",
          "2004",
          "2005",
          "2006",
          "2007",
          "2008",
          "2009",
          "2010",
          "2011",
          "2012",
          "2013",
          "2014",
          "2015",
          "2016",
          "2017",
          "2018",
          "2019",
          "2020",
          "2021",
          "2022",
          "2023",
          "2024",
          "2025",
          "2026",
          "2027",
          "2028",
          "2029",
          "2200",
          "2201",
          "2202",
          "2203",
          "HK03",
          "HK04"
        ]        
      } ,
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyControllerType",
        options: [
          "PLC", 
          "301",
          "401A",
          "401B",
          "501A",
          "501B",
          "NON-KONE",
          "KSE",
          "MMS_501B_U",
          "MMS_501B_TBU",
          "101",
          "201"
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyOperationMode",
        options: [
          "KCM",    
          "KSD",    
          "KSS",    
          "KAM",    
          "K2D",    
          "KSB",    
          "KST",    
          "KMS",    
          "KVS",    
          "KDB",    
          "KIB",    
          "KRD",    
          "KEM",   
          "KBSB",    
          "KBST",
          "NOT_KNOWN"
        ]
      },
      {
        type: "number",
        id: "escalatorVAsiteSurveyInstallationYear",
        min: 1900,
        max: 0, // 0 means current year
        minLength: 4,
        maxLength: 4,
        validityRegExp: /^\d+$/
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyEquipmentHasBeenModernized",
        options: [
          "yes",
          "no"
        ],
        defaultSelection: "no"
      },
      {
        type: "number",
        id: "escalatorVAsiteSurveyEquipmentModernizationYear",
        min: 1900,
        max: 0, // 0 means current year
        minLength: 4,
        maxLength: 4,
        validityRegExp: /^\d+$/,
        selectionConditionId: "escalatorVAsiteSurveyEquipmentHasBeenModernized",
        selectionConditions: ["yes"]
      },
      {
        type: "number",
        id: "escalatorVAsiteSurveyNoVisibleSteps",
        min: 0,
        max: 10000,
        minLength: 1,
        maxLength: 5,
        validityRegExp: /^\d+$/
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyIsAutowalk",
        options: [
          "yes",
          "no"
        ],
        defaultSelection: "no"
      },
    ]
  },
  {
    step: "entryEnd",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyAccessCoverPlates",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyAccessCoverPlates",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveyAccessCoverPlatesImage",
        helpText: "escalatorVAsiteSurveyAccessCoverPlatesImage",
        showTitle: true
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyEntryEndColumnsExistence",
        options: [
          "yes",
          "no"
        ],
        selectionConditionId: "escalatorVAsiteSurveyIsAutowalk",
        selectionConditions: ["no"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyEntryEndColumnsExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyElectricConnectionUpgrade",
        options: [
          "yes",
          "no"
        ],
        selectionConditionId: "escalatorVAsiteSurveyEntryEndColumnsExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyElectricConnectionUpgrade",
        selectionConditions: ["yes"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyEscalatorInnerDeck",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyEscalatorInnerDeck",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveySafetyStickersImage",
        helpText: "escalatorVAsiteSurveySafetyStickersImage",
        showTitle: true
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHRinletReplacement",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHRinletReplacement",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombSegmentReplacement",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCombSegmentReplacement",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombCarrierPlateAtTheEntryEndReplacement",
        options: [
          "GOOD",
          "TO_BE_ADJUSTED"
        ],
        selectionConditionId: "escalatorVAsiteSurveyPlatform",
        selectionConditions: [
          "1000",
          "1003",
          "1207",
          "1035",
          "1033",
          "1034",
          "1001",
          "1006",
          "1002",
          "1026",
          "1007",
          "1031",
          "1032"
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyDeckOrSkirtReplacement",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyDeckOrSkirtReplacement",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySkirtBrushExistence",
        options: [
          "yes",
          "no"
        ],
        selectionConditionId: "escalatorVAsiteSurveyIsAutowalk",
        selectionConditions: ["no"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySkirtBrushExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySkirtBrushReplacement",
        options: [
          "GOOD",
          "WORN",
          "NOTSAFE"
        ],
        selectionConditionId: "escalatorVAsiteSurveySkirtBrushExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySkirtBrushReplacement",
        selectionConditions: ["NOTSAFE"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveySkirtBrushImage",
        helpText: "escalatorVAsiteSurveySkirtBrushImage",
        showTitle: true,
        selectionConditionId: "escalatorVAsiteSurveySkirtBrushExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyOuterDecks",
        options: [
          "GOOD",
          "WORN",
          "NOTSAFE"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyOuterDecks",
        selectionConditions: ["NOTSAFE"],
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveySurveyAdditionalInfoEntryEnd",
      }
    ]
  },
  {
    step: "lighting",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyTrafficLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyTrafficLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyTrafficLightCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyTrafficLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyTrafficLightCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHandrailLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHandrailLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHandrailLightCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyHandrailLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHandrailLightCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySkirtLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySkirtLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySkirtLightCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveySkirtLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySkirtLightCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepGapLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyStepGapLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepGapLightCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyStepGapLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyStepGapLightCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCombLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombLightExistenceCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyCombLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCombLightExistenceCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCladdingSoffitLightExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCladdingSoffitLightExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCladdingSoffitLightCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyCladdingSoffitLightExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCladdingSoffitLightCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveySurveyAdditionalInfoLighting",
      }
    ]
  },
  {
    step: "safetyComponents",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyBallustradePanels",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyBallustradePanels",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveyBallustradePanelsImage",
        helpText: "escalatorVAsiteSurveyBallustradePanelsImage",
        showTitle: true
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepCleanliness",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepsribs",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyStepsribs",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveystepImage",
        helpText: "escalatorVAsiteSurveystepImage",
        showTitle: true
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepDemarcation",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyStepDemarcation",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyguardsHeadguardExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyguardsHeadguardExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyGuardsHeadGuard",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveySafetyguardsHeadguardExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyGuardsHeadGuard",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardCondition",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardCondition",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyExitEndColumnsExistence",
        options: [
          "yes",
          "no",
          "NOT_APPLICABLE"
        ],
        defaultSelection: "NOT_APPLICABLE"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyExitEndColumnsExistence",
        selectionConditions: ["no"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyElectricConnectionUpgradeExitEnd",
        options: [
          "GOOD",
          "POOR_COND" 
        ],
        selectionConditionId: "escalatorVAsiteSurveyExitEndColumnsExistence",
        selectionConditions: ["yes"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyElectricConnectionUpgradeExitEnd",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyAccessCoverAtExitEnd",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyAccessCoverAtExitEnd",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "image",
        id: "escalatorVAsiteSurveyAccessCoverPlatesAtExitEndImage",
        helpText: "escalatorVAsiteSurveyAccessCoverPlatesAtExitEndImage",
        showTitle: true
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombsAtExitEnd",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCombsAtExitEnd",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCombCarrierPlatesAtExitEnd",
        options: [
          "GOOD",
          "TO_BE_ADJUSTED" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCombCarrierPlatesAtExitEnd",
        selectionConditions: ["TO_BE_ADJUSTED"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveySafetyStickersUserInstructionsStopButtonLocation",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveySafetyStickersUserInstructionsStopButtonLocation",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHRInletFrontPlatesBothLHAndRH",
        options: [
          "GOOD",
          "POOR_COND" 
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHRInletFrontPlatesBothLHAndRH",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCheckHandrailTraction",
        options: [
          "GOOD",
          "TO_BE_ADJUSTED" 
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHandrailsOutsideInside",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHandrailsOutsideInside",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyHandrailGuides",
        options: [
          "GOOD",
          "WORN",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyHandrailGuides",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyStepstepGapStepAlignmentAtCombArea",
        options: [
          "GOOD",
          "WORN",
          "STEP_CHAIN_REPLACEMENT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyStepstepGapStepAlignmentAtCombArea",
        selectionConditions: ["STEP_CHAIN_REPLACEMENT_NEEDED"],
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveySurveyAdditionalInfoSafetyComponents",
      }
    ]
  },
  {
    step: "lowerPitTruss",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyPitLightsocket",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyPitLightsocket",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyPitCleanliness",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyTrussCleanliness",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveyAdditionalInfoLowerPitTruss",
      }
    ]
  },
  {
    step: "upperPit",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyUpperPitCleanliness",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyLubricators",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyLubricators",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyBrakeLinerThickness",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyBrakeLinerThickness",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveySurveyAdditionalInforUpperPitTruss",
      }
    ]
  },
  {
    step: "controller",
    fields: [
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyInverterFans",
        options: [
          "GOOD",
          "POOR_COND"
        ],
        //selectionConditionId: "escalatorVAsiteSurveyOperationMode",
        //selectionConditions: ["<THIS SHALL BE DEFINED BY MATTI"]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyInverterFans",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCabinetFans",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCabinetFans",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "dropdown",
        id: "escalatorVAsiteSurveyCabinetFilters",
        options: [
          "GOOD",
          "POOR_COND"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyCabinetFilters",
        selectionConditions: ["POOR_COND"],
      },
      {
        type: "number",
        id: "escalatorVAsiteSurveyMaincontactorsRelaysBrakeAuxBrakesReplacementYear",
        min: 1900,
        max: 0, // 0 means current year
        minLength: 4,
        maxLength: 4,
        validityRegExp: /^\d+$/,
        helpText:"escalatorVAsiteSurveyMaincontactorsRelaysBrakeAuxBrakesReplacementYearHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyMaincontactorsRelaysBrakeAuxBrakesReplacementYear",
        isOlderThanYears: 5
      },
      {
        type: "number",
        id: "escalatorVAsiteSurveyInverterReplacementYear",
        min: 1900,
        max: 0, // 0 means current year
        minLength: 4,
        maxLength: 4,
        validityRegExp: /^\d+$/
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "escalatorVAsiteSurveyInverterReplacementYear",
        isOlderThanYears: 10
      },
      {
        type: "text-area",
        id: "escalatorVAsiteSurveyAdditionalInfoController",
        helpText: "escalatorVAsiteSurveyAdditionalInfoControllerHelpText"
      }
    ]
  } 
];
